import { styled } from "@mui/material/styles";
import { Box, Dialog, Typography, alpha, DialogContent, DialogActions } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export const StyledDialog = styled(Dialog)(({theme}) => ({
  "& .MuiPaper-root": {
    overflow: "visible",
    borderRadius: "14px",
    maxWidth: "580px",
        width: "100%",
    backgroundColor: theme.palette.background.common
  },
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(1),
  textAlign: "center",
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
    display: "block",
    lineHeight: 1.5,
    textAlign: "left",
    color: theme.palette.text.secondary
}));

export const ChangelogBox = styled(Box)(({ theme }) => ({
    width: "100%",
    height: "100%",
    maxHeight: "200px",
    backgroundColor: alpha(theme.palette.primary.main, 0.07),
    borderRadius: "10px",
    padding: theme.spacing(2),
    paddingBottom: "8px",
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
        width: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#B0BEC5",
        borderRadius: "4px",
    },
    "&::-webkit-scrollbar-track": {
        backgroundColor: "#ECEFF1",
        borderRadius: "4px",
    },
}));

export const ChangelogTitle = styled(Typography)(({ theme }) => ({
    alignSelf: "center",
    marginBottom: theme.spacing(1),
    textTransform: "uppercase",
    color: theme.palette.primary.main
}));

export const StyledCheckCircleIcon = styled(CheckCircleIcon)(({ theme }) => ({
    color: theme.palette.primary.main,
    marginTop: "2px",
    marginRight: theme.spacing(1),
    flexShrink: 0,
    fontSize: "22px" 
}))

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    paddingTop: theme.spacing(1)
}));

export const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  justifyContent: "flex-end",
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1),
  minWidth: 80,
}));

export const ChangelogList = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
}));